//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  data() {
    return {
      sticky: false,
    }
  },
  props: {
    blok: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    if (process.browser && this.location && this.order && this.$route.name !== 'menu-mid') {
      this.$router.push('/order/')
    }
    if (process.browser && window.location.hash.length) {
      if (window.location.hash) {
        setTimeout(
          function() {
            let hash = window.location.hash.replace('#', '')
            if (hash !== '') {
              this.$store.commit('setActiveSection', hash)
            }
          }.bind(this),
          100
        )
      }
    }
    if(process.browser && this.menu) {
      let found = false
      this.menu.categories.map(c => {
        if(this.slug(c.name) == this.activeSection) {
          found = true
          this.loadCategory(c.id)
        }
      })
      if(process.browser && !found) {
        this.loadCategory(this.menu.categories[0].id)
      }
    }
    window.addEventListener('hashchange', this.hashchange)
  },
  destroyed() {
    window.removeEventListener('hashchange', this.hashchange)
  },
  methods: {
    loadCategory(id) {
      if(this.menu) {
        this.menu.categories.map(c => {
          if(c.id == id && c.products.length < 1) {
            this.$api.getMenuProducts(id)
          }
        })
      } else {
        this.displayMenu.categories.map(c => {
          if(c.id == id && c.products.length < 1) {
            this.$api.getMenuProducts(id)
          }
        })
      }
    },
    hashchange() {
      if (window.location.hash) {
        setTimeout(
          function() {
            // this.activeSection = window.location.hash.replace('#', '')
          }.bind(this),
          100
        )
      }
    },
    // scroll() {
    //   let top = document.querySelector('.order-categories > nav:first-of-type').getBoundingClientRect().top
    //   if (top >= 0) {
    //     this.sticky = false
    //   } else {
    //     this.sticky = true
    //   }
    //   if (top < 650) {
    //     this.icons = true
    //   } else {
    //     this.icons = false
    //   }
    // },
    async nav(name, cid) {
      this.loadCategory(cid)
      let id = this.slug(name)
      // this.activeSection = id
      this.$store.commit('setActiveSection', id)
      // scroll to active section
      // let nav = document.querySelector('.order-categories nav:not(.sticky)')
      // let li = document.querySelector('.order-categories nav:not(.sticky) li.active')
      // // nav.scrollIntoView({ behavior: 'smooth' })
      // // let offset = window.innerWidth - li.getBoundingClientRect().left
      // setTimeout(function() {
      //   li.scrollIntoView({ behavior: 'smooth', top: -500 })
      // }, 250)
    },
    slug(str) {
      str = str.toString().replace(/^\s+|\s+$/g, '')
      str = str.toLowerCase();
      let from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
      let to   = "aaaaeeeeiiiioooouuuunc------"
      for (let i=0, l=from.length ; i<l ; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }
      str = str.replace(/[^a-z0-9 -]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-')

      return str
    },
    titleCase(str) {
      return str.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase())
    },
  },
  computed: {
    ...mapState([ 'defaultMenu', 'menu', 'options', 'order', 'location', 'activeSection' ]),
    displayMenu() {
      return this.blok.default_menu ? this.defaultMenu : this.menu
    },
  },
  watch: {
    $route(to, from) {
      if (window.location.hash) {
        setTimeout(
          function() {
            // this.activeSection = window.location.hash.replace('#', '')
            let hash = window.location.hash.replace('#', '')
            this.$store.commit('setActiveSection', hash)
            window.scroll({ top: 0, left: 0, behavior: 'smooth' }) // scroll to top on route change
          }.bind(this),
          100
        )
      }
    }
  }
}
